import React from 'react';
import { useSelector, } from 'react-redux';
import { Button, Card } from 'react-bootstrap';
import { getImageUrl, getRandomImage } from '../../../../../configs/configs';
import { formatDate } from '../../../../../configs/configs';
import history from '../../../../../history';

//comps
import AdminMenu from '../../../../common/AdminMenu/AdminMenu';
import CustomToggleDropdown from '../../../../common/CustomToggleDropdown/CustomToggleDropdown';
import TileActionMenu from '../MainDashboard/Breaches/TileActionMenu';

const NewsItem = ({ item, onBreachItemClick, target }) => {
  //redux
  const currentUser = useSelector(state => state.currentUser);
  const pathname = history.location.pathname;
  console.log(pathname);

  const getTitle = () => {
    if (onBreachItemClick) return <span className="pointer" onClick={() => onBreachItemClick(item)}>{item.title}</span>;
    if (target) return <a href={(item.relatedThreats > 0 || item.threatsCount > 0) ? `/dashboard/breach/${item._id}` : item.url1} rel="noreferrer" target="_blank">{item.title}</a>;
    return <span className="pointer">{item.title}</span>;
  };

  const getDescription = () => {
    if (onBreachItemClick) return <p className="dashboard-card-sm-vertical-body line-clamp-5 pointer" onClick={() => onBreachItemClick(item)}>{item.detailedDescription}</p>;
    if (target) return <a href={(item.relatedThreats > 0 || item.threatsCount > 0) ? `/dashboard/breach/${item._id}` : item.url1} rel="noreferrer" target="_blank"><p className="dashboard-card-sm-vertical-body line-clamp-5">{item.detailedDescription}</p></a>;
    return <p className="dashboard-card-sm-vertical-body line-clamp-5 pointer">{item.detailedDescription}</p>;
  };

  const getImage = () => {
    if (onBreachItemClick) return <img alt='item main' className="img-fluid pointer" src={getImageUrl(item.image) || getRandomImage()} onClick={() => onBreachItemClick(item)} />;
    if (target) return <a href={(item.relatedThreats > 0 || item.threatsCount > 0) ? `/dashboard/breach/${item._id}` : item.url1} rel="noreferrer" target="_blank"><img alt='item main' className="img-fluid" src={getImageUrl(item.image) || getRandomImage()} /></a>;
    return <img alt='item main' className="img-fluid pointer" src={getImageUrl(item.image) || getRandomImage()} />;
  };

  return (
    <div className="mb-3 news-tile-card">
      <Card className="dashboard-card dashboard-card-sm-vertical box-shadow">
        <div className="dashboard-card-sm-vertical__content">

          {/* ------ Title -------- */}
          <div className="d-flex justify-content-between">
            <h4 className="dashboard-card-sm-vertical-title line-clamp-3">

              {pathname.includes('breach') || pathname.includes('threat') || pathname.includes('malware') || pathname.includes('actor') || pathname.includes('cve') || pathname.includes('blog') || pathname.includes('ciso')
                ? getTitle()
                : <a href={item.url1} rel="noreferrer" target="_blank">{item.title}</a>}

            </h4>

            <TileActionMenu item={item} />

          </div>

          {/* ------ Description -------- */}
          {item.detailedDescription && <div>
            {pathname.includes('breach') || pathname.includes('threat') || pathname.includes('malware') || pathname.includes('actor') || pathname.includes('cve') || pathname.includes('blog') || pathname.includes('ciso')
              ? getDescription()
              : <a href={item.url1} rel="noreferrer" target="_blank"><p className="dashboard-card-sm-vertical-body line-clamp-5">{item.detailedDescription}</p></a>}
          </div>}

          <div className="d-flex flex-column justify-content-between dashboard-card-sm-vertical-footer">
            <div>

              {/* ------ IOCS and TTPs -------- */}
              <div className="d-flex justify-content-between align-items-center pb-2">
                {(item.relatedThreats > 0 || item.threatsCount > 0) && <div className="d-flex">
                  <a href={`/dashboard/breach/${item._id}`} target="_blank" rel="noreferrer"><span className="related-Ioc pointer mr-3"><span>{item.allIocsSize} IOCs</span></span></a>
                  <a href={`/dashboard/breach/${item._id}`} target="_blank" rel="noreferrer">
                    <div className="related-Count pointer">
                      <span className="related-Count__count">{item.relatedThreats || item.threatsCount} TTPs</span>
                    </div>
                  </a>
                </div>}
                {item?.newTag5 === 'Breach' && <span className="ml-auto text-red">Breach</span>}
                {item?.newTag5 === 'Vulnerability' && <span className="ml-auto">Vulnerability</span>}
              </div>

              {/* ------ Image & Threats Count -------- */}
              <div className="position-relative">

                {/* <a href={item.url1} rel="noreferrer" target="_blank"><img alt='item main' className="img-fluid" src={getImageUrl(item.image) || getRandomImage()} /></a> */}

                {pathname.includes('breach') || pathname.includes('threat') || pathname.includes('malware') || pathname.includes('actor') || pathname.includes('cve') || pathname.includes('blog') || pathname.includes('ciso')
                  ? getImage()
                  : <a href={item.url1} rel="noreferrer" target="_blank"><img alt='item main' className="img-fluid" src={getImageUrl(item.image) || getRandomImage()} /></a>}
                {['admin', 'owner'].includes(currentUser.userRole) && <CustomToggleDropdown
                  optionsArray={
                    <AdminMenu item={item} />
                  }
                  onItemClick={(option) => { }}>
                  <Button className="admin-edit p-1" size="sm">admin</Button>
                  {/* <span className="material-icons admin-edit" >create</span> */}
                </CustomToggleDropdown>}
              </div>
            </div>

            {/* ------ Date -------- */}
            <div className="d-flex">
              <span>{item.newTag8}</span>
              <span className="ml-auto">{formatDate(item.exactDate, 'day month, year')}</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default NewsItem;
